"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateEffectivePrice = exports.formatCurrency = exports.generateOrderNumber = exports.isValidPhone = exports.isValidEmail = void 0;
// Export all types
__exportStar(require("./types/index"), exports);
// Utility functions
const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
exports.isValidEmail = isValidEmail;
const isValidPhone = (phone) => {
    const phoneRegex = /^\+?[\d\s\-\(\)]+$/;
    return phoneRegex.test(phone) && phone.replace(/\D/g, '').length >= 10;
};
exports.isValidPhone = isValidPhone;
const generateOrderNumber = () => {
    const timestamp = Date.now().toString(36).toUpperCase();
    const random = Math.random().toString(36).substr(2, 4).toUpperCase();
    return `ORD-${timestamp}-${random}`;
};
exports.generateOrderNumber = generateOrderNumber;
const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(amount);
};
exports.formatCurrency = formatCurrency;
const calculateEffectivePrice = (basePrice, distributorMarkup = 0, physicianMarkup = 0) => {
    return basePrice * (1 + distributorMarkup / 100) * (1 + physicianMarkup / 100);
};
exports.calculateEffectivePrice = calculateEffectivePrice;
__exportStar(require("./customStore"), exports);
__exportStar(require("./productQualification"), exports);
__exportStar(require("./intakeProgram"), exports);
__exportStar(require("./doseLadder"), exports);
__exportStar(require("./storeCoverage"), exports);
__exportStar(require("./analyticsEvents"), exports);
//# sourceMappingURL=index.js.map